module.exports = __webpack_public_path__ + "static/media/intro.5c539fae.mp3";